import { useState, ReactNode, Children, isValidElement } from 'react'
import './DetailsAccordion.css'

interface AccordionSectionProps {
  title: string
  badge?: string
  defaultOpen?: boolean
  children: ReactNode
}

export function AccordionSection({ title, badge, defaultOpen = false, children }: AccordionSectionProps) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div className={`accordion-section ${open ? 'open' : ''}`}>
      <button
        type="button"
        className="accordion-header"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="accordion-chevron">{open ? '▼' : '▶'}</span>
        <span className="accordion-title">{title}</span>
        {badge && <span className="accordion-badge">{badge}</span>}
      </button>
      {open && <div className="accordion-content">{children}</div>}
    </div>
  )
}

interface DetailsAccordionProps {
  children: ReactNode
}

function DetailsAccordion({ children }: DetailsAccordionProps) {
  // Verify children are AccordionSection elements; passthrough otherwise
  const sections = Children.toArray(children).filter((c) =>
    isValidElement(c) && c.type === AccordionSection
  )
  return <div className="details-accordion">{sections}</div>
}

export default DetailsAccordion
